import React from 'react'

//styles
import {
  PrimaryButton,
  BasicPrimaryButton,
  WarningButton,
  AddButton,
  SubtractButton,
  Count,
  AddSubContainer,
} from './Buttons.styles'

export const Primary = ({ children, ...rest }) => (
  <PrimaryButton data-qa={`primaryButton-${children}`} {...rest}>{children}</PrimaryButton>
)

export const Basic = ({ children, ...rest }) => (
  <BasicPrimaryButton data-qa={`basicButton-${children}`} {...rest}>{children}</BasicPrimaryButton>
)

export const Warning = ({ children, ...rest }) => (
  <WarningButton data-qa={`warningButton-${children}`} {...rest}>{children}</WarningButton>
)

export const AddSubComponent = ({ add, sub, count, children, ...rest }) => (
  <AddSubContainer>
    <SubtractButton data-qa="subButton" onClick={sub} {...rest}>
      -
    </SubtractButton>
    <Count data-qa="addSubCount">{count}</Count>
    <AddButton data-qa="addButton" onClick={add} {...rest}>
      +
    </AddButton>
  </AddSubContainer>
)
